import { ShipClockScreen } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import { officeShipClockSource } from '../ship-clock-source.js';

/** Crew ▸ Ship's Clock Log (M18; ADR 0065): gemiden gelen saat kaydı, salt okunur. */
export function ShipClockPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('shipClock.title')}>
      <ShipClockScreen source={officeShipClockSource} />
    </Shell>
  );
}
